import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Chip,
  TextField,
  InputAdornment,
} from "@material-ui/core";
import { useState } from "react";
import ArrowDropDownIcon from "@material-ui/icons/ArrowDropDown";
import SearchInputDebounced from "./SearchInputDebounced";
import FormGroup from "@mui/material/FormGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import { FETCH_PRODUCTS } from "../graphql/queries";
import { useQuery } from "@apollo/client";

export default function SelectFilterModalProduct({
  onChange,
  loading,
  title,
  required,
  error,
  fullWidth,
  style,
  margin,
  errorLabel,
  value,
  productState,
}) {
  const [newValueProduct, setNewValueProduct] = useState(productState || []);
  const [showDialog, setShowDialog] = useState(false);

  const { data } = useQuery(FETCH_PRODUCTS);

  // // Search
  const [searchTerm, setSearchTerm] = useState(null);

  const handleChangeCheckbox = (e) => {
    const value = parseInt(e.target.value);
    let index = newValueProduct.findIndex((id) => id === value);

    if (index >= 0 && e.target.checked === false) {
      deleteItem(index);
    } else {
      let clone = [...newValueProduct];
      clone.push(value);
      setNewValueProduct(clone);
    }
  };

  const deleteItem = (index) => {
    let clone = [...newValueProduct];
    clone.splice(index, 1);
    setNewValueProduct(clone);
  };

  const handleSelect = () => {
    onChange(newValueProduct);
    setShowDialog(false);
  };

  const handleClearFilter = () => {
    onChange(value);
    setNewValueProduct([]);
    setSearchTerm(null);
    setShowDialog(false);
  };

  return (
    <>
      <TextField
        style={style}
        InputProps={{
          readOnly: true,
          endAdornment: (
            <InputAdornment position="end">
              <ArrowDropDownIcon
                style={{ color: "#787878", marginRight: -6 }}
              />
            </InputAdornment>
          ),
        }}
        InputLabelProps={{
          shrink: newValueProduct.length > 0,
        }}
        onClick={() => {
          setShowDialog(true);
        }}
        variant="outlined"
        fullWidth={fullWidth}
        required={required}
        value={newValueProduct
          .map(
            (productId) =>
              data?.fetchProducts.data.find((product) => product.id === productId)?.name
          )
          .join(", ")}
        label={title}
        margin={margin}
        error={error}
        helperText={errorLabel}
      />

      <Dialog
        open={showDialog}
        onClose={() => setShowDialog(false)}
        maxWidth="md"
      >
        <DialogTitle>{"Empresa"}</DialogTitle>
        <DialogContent>
          <SearchInputDebounced
            typeSearch="inDialog"
            onChange={(value) => {
              setSearchTerm(value);
            }}
          />

          <div style={{ marginTop: 20, width: 300 }}>
            {newValueProduct.map((productId, index) => {
              const productName = data?.fetchProducts.data.find(
                (product) => product.id === productId
              )?.name;
              return (
                <Chip
                  label={productName}
                  onDelete={() => deleteItem(index)}
                  key={productId}
                />
              );
            })}
          </div>

          <div
            style={{
              marginTop: 20,
              height: 300,
              overflow: "auto",
              display: "flex",
              flexDirection: "column",
            }}
          >
            <FormGroup>
              <div style={{ display: "flex", flexDirection: "column" }}>
                {data &&
                  data?.fetchProducts.data.map((reason) => (
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={newValueProduct.includes(reason.id)}
                          value={reason.id}
                          onChange={handleChangeCheckbox}
                        />
                      }
                      label={reason.name}
                    />
                  ))}
              </div>
            </FormGroup>
          </div>
        </DialogContent>

        <DialogActions>
          <Button onClick={handleClearFilter} color="primary">
            Limpar
          </Button>
          <Button
            onClick={handleSelect}
            variant="contained"
            color="primary"
            disabled={loading}
          >
            Selecionar
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
